// Seule l'enveloppe `responses[0]` porte le tableau {message, field, context} attendu par
// formValidator.processResponses. `response.validationErrors` (EstimateController) est un objet
// associatif champ => message, exploité directement par ses vues : forme incompatible, hors périmètre.
export const extractValidationErrors = (data) => data?.responses?.[0]?.validationErrors ?? null;

// `success: false` est un échec métier au même titre que `hasError` (cf. TrainingSkillComponent.modalSubmit).
export const extractMutationVerdict = (data) => ({
  ok: !data?.hasError && data?.success !== false,
  validationErrors: extractValidationErrors(data),
});
